import React from "react";
import { forgotpassword } from "../../../lib/forgotpassword";
import { changepassword } from "../../../lib/changepassword";
import { login } from "../../../lib/login";
import { signup, checkregisterstatus } from "../../../lib/signup";
import ModalPopupComponent from "../../ModalPopupComponent/theme7/ModalPopupComponent";
import ChangePassword from "../ChangePassword";
import ChangePasswordMob from "./ChangePasswordMob";
import { setTockenInCoockie, setRefreshTockenInCoockie } from "../userToken";
import IsdCountryDropdown from "../../IsdCountryDropdown/index";
import CountryDropdownComp from "../../CountryDropdown/index";
import { register } from "../../../lib/register";
import FacebookGoogleLogin from "./FacebookLogin";
import CaptchaComponent from "../CaptchaComponent";
import getCountriesList from "../../../lib/getCountriesList";
// import  LoginFlow from './indexNewFlow'
import { tokenExpiry } from "../../../lib/tokenExpiry";
import ResetPassword from "../ResetPassword";
import { encryptData } from "../../../../common/lib/crypto/crypto";

const errorsList = {
  firstName: {
    ERFN101: "Please Enter First Name",
  },
  lastName: {
    ERLN101: "Please Enter Last Name",
  },
  countryCode: {
    ERCC101: "Please Select The Country Code",
  },
  nationality: {
    ERNT101: "Please Select Country",
  },
  mobileNo: {
    ERMN101: "Invalid Mobile Number",
    ERMN102: "Please Enter Mobile Number",
  },
  email: {
    ERE101: "Please Enter Email Id",
    ERE102: "Please Enter Valid Email Id",
  },
  password: {
    ERP101:
      "Password must be between 8-13 characters in length and must comprise of at least 1 lowercase alphabet (a-z), 1 uppercase alphabet (A-Z), 1 number (0-9) and 1 special character",
    ERP104: "Please Enter Password",
    ERP105: "Invalid Password Entered",
    ERP106:
      "The minimum password length is 8 characters and must contain at least 1 lowercase letter, 1 capital letter, 1 number and 1 special character.",
  },
  confirmPassword: {
    ERP102: "Please Confirm New Password",
    ERP103: "Passwords Do Not Match",
  },
  OTP: {
    EROTP101: "Please Enter OTP",
    EROTP102: "Please Enter Valid OTP",
  },
  isTermsChecked: {
    ERTC101: "Please Accept The Terms & Conditions To Proceed",
  },
};

const emailPattern =
  /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
let pwsEx = new RegExp(
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{8,13}$/
);
var alphabetonly = new RegExp(/^[a-zA-Z_\s]*$/);
let otpregex = new RegExp(/[a-z0-9]*\\d[a-z0-9]*/);
let alphanumericAndSpecialChars = new RegExp(/^[ A-Za-z0-9_@./#&+-]*$/);
export default class Theme1 extends React.Component {
  constructor(props) {
    console.log(props, "login component");
    super(props);
    this.state = {
      toggleAgentLogin: false,
      headerPopup: true,
      popupType: "LogIn",
      logincred: { email: "", password: "" },
      loginErrors: { email: "", password: "" },
      loginErrorMsg: "",
      signUpEmail: "",
      signUpEmailErr: "",
      registerAPIErr: "",
      onClickLoginLoader: false,
      activationLink: false,
      forgotPasswordEmail: "",
      forgotPassText: false,
      forgotPasswordErr: "",
      loginWithOTPEmail: "",
      loginOTPEmailErr: "",
      verifyOTPEmail: "",
      verifyOTPEmailErr: "",
      signUpWithCaptchaMail: "",
      signUpWithCaptchaMailErr: "",
      passwordObj: { newPassword: "", confirmPassword: "" },
      passwordObjErr: { newPassword: "", confirmPassword: "" },
      changePasswordAPIErr: "",
      searchCountryText: "",
      selectedCountry: {
        countryFlag: "/theme5/india_flag.png",
        countryCode: "IN",
        isdCode: "91",
      },
      selectedNationality: "",
      signupForm: {
        firstName: "",
        lastName: "",
        countryCode: "+91",
        mobileNo: "",
        nationality: "",
        email: this.props.data.emailId !== "" ? this.props.data.emailId : "",
        password: "",
        confirmPassword: "",
      },
      signupFormErr: {
        firstName: "",
        lastName: "",
        countryCode: "",
        mobileNo: "",
        nationality: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      setToken: "",
      bounz_register: false,
      isCaptchaSelected: false,
      captchErrorMsg: "",
      originCountries: [],
      isSuccessPopupVisible: false,
      isReadOnly: true,
      isPasswordRequired: true,
      registrationToken: "",
      hidePass: false,
      hidePassConf: false,
      resetTokenExpiry: false,
    };
  }

  componentDidMount = () => {
    if (
      this.props.data.resetToken !== "" &&
      this.props.data.resetToken !== null
    ) {
      let response = {
        resettoken: this.props.data.resetToken,
        site_id: this.props.data.siteData?.data?.site_id,
      };
      tokenExpiry(response).then((resp) => {
        console.log(resp);
        if (resp && resp.data.status) {
          // setResetTokenExpiry(false)
          this.setState({ resetTokenExpiry: false });
        } else {
          // setResetTokenExpiry(true)
          this.setState({ resetTokenExpiry: true });
        }
      });
    }

    if (
      this.props.data.directOpenLinkPopup === "SignUp" ||
      this.props.data.directOpenLinkPopup === "LogIn" ||
      this.state.popupType === "SignUp" ||
      this.props.data.directOpenLinkPopup === "BeforeSignUp"
    ) {
      getCountriesList().then((resp) => {
        let countryList = [];
        if (resp?.data?.length > 0) {
          resp?.data.map((item) => {
            countryList.push({
              ...item,
              value: item.contry_name,
              isdCode: item.contry_isd,
              countryCode: item.contry_code,
              flag: item.contry_flag,
              countryFlag: item.contry_flag,
              countryName: item.contry_name,
            });
          });
        }
        this.setState({ originCountries: countryList });
      });
    }
  };

  // Login Functinality Starts
  onChangeLoginEmail = (e) => {
    this.setState({
      logincred: { ...this.state.logincred, email: e.target.value },
      loginErrors: { ...this.state.loginErrors, email: "" },
    });
  };
  onChangeLoginPassword = (e) => {
    let spaceEX = new RegExp(/(^\S*$)/);
    let confpwsEx = new RegExp(/^(?=.{0,13}$).*/);
    if (e.target.value.match(confpwsEx) && e.target.value.match(spaceEX)) {
      this.setState({
        logincred: { ...this.state.logincred, password: e.target.value },
        loginErrors: { ...this.state.loginErrors, password: "" },
      });
    } else {
      this.setState({
        loginErrors: {
          ...this.state.loginErrors,
          password: "Please Enter Valid Password",
        },
      });
    }
  };
  //login in button
  onClickLoginBtn = async () => {
    this.setState({
      loginErrors: {
        ...this.state.loginErrors,
        email:
          this.state.logincred.email === ""
            ? errorsList.email.ERE101
            : /* (this.state.logincred.email.match(emailPattern) !== null) ? */ "" /* : errorsList.email.ERE102 */,
        password:
          this.state.logincred.password === ""
            ? errorsList.password.ERP104
            : this.state.logincred.password.match(pwsEx) !== null
            ? ""
            : errorsList.password.ERP105,
      },
      loginErrorMsg: "",
    });
    if (
      this.state.logincred.email !== "" &&
      this.state.logincred.password !== "" &&
      this.state.logincred.password.match(pwsEx) !==
        null /* && (this.state.logincred.email.match(emailPattern) !== null) */
    ) {
      let encryptedPassword = encryptData(this.state.logincred.password);
      let loginReq = {
        email: this.state.logincred.email,
        password: encryptedPassword, // this.state.logincred.password,
        type: this.state.toggleAgentLogin ? "agent" : undefined,
        crypto: true ? true : false,
      };
      this.setState({ onClickLoginLoader: true });
      login(loginReq).then((responseJSON) => {
        console.log("responseJSON", responseJSON);
        this.setState({ onClickLoginLoader: false });
        if (
          responseJSON.status === true &&
          responseJSON.accessToken !== "" &&
          responseJSON.accessToken !== undefined &&
          responseJSON.accessToken !== null
        ) {
          this.props.data.onClickCross();
          location.reload();
        } else if (!responseJSON.status && responseJSON.isPartialRegister) {
          if (
            typeof this?.props?.data?.clearDirectOpenLinkPopup === "function"
          ) {
            this.props.data.clearDirectOpenLinkPopup();
          }
          this.setState({
            popupType: "SignUp",
            isPasswordRequired: true,
            registrationToken: responseJSON.registration_token,
            signupForm: {
              ...this.state.signupForm,
              email: this.state.logincred.email,
            },
          });
        } else {
          this.setState({
            loginErrorMsg:
              typeof responseJSON.message === "string"
                ? responseJSON.message
                : "",
          });
        }
      });
    }
  };
  checkregisterstatus = async () => {
    console.log("check register fn called");
    this.setState({
      loginErrors: {
        ...this.state.loginErrors,
        email:
          this.state.logincred.email === ""
            ? errorsList.email.ERE101
            : /* (this.state.logincred.email.match(emailPattern) !== null) ? */ "" /* : errorsList.email.ERE102 */,
      },
      loginErrorMsg: "",
    });
    if (this.state.logincred.email !== "") {
      console.log("login valid..");
      let loginReq = {
        email: this.state.logincred.email,
      };
      checkregisterstatus(loginReq).then((responseJSON) => {
        if (responseJSON.isPartialRegister) {
          if (
            typeof this?.props?.data?.clearDirectOpenLinkPopup === "function"
          ) {
            this.props.data.clearDirectOpenLinkPopup();
          }
          this.setState({
            popupType: "SignUp",
            isPasswordRequired: true,
            registrationToken: responseJSON.registration_token,
            signupForm: {
              ...this.state.signupForm,
              email: this.state.logincred.email,
            },
          });
        }
      });
    }
  };
  //Login Func Ended

  //signup Email
  onChangeSignupEmailId = (e) => {
    this.setState({
      signUpEmail: e.target.value,
      signUpEmailErr: "",
      activationLink: false,
    });
  };

  onChangeBounzCheck = (value) => {
    // console.log("value", value)
    this.setState({ bounz_register: value });
  };
  onClickSignupBtn = () => {
    // console.log(this.props?.data?.siteData?.site?.login_captcha_key,"captcha key");
    this.setState({
      signUpEmailErr:
        this.state.signUpEmail === ""
          ? errorsList.email.ERE101
          : this.state.signUpEmail.match(emailPattern) !== null
          ? ""
          : errorsList.email.ERE102,
    });
    if (
      this.state.signUpEmail !== "" &&
      this.state.signUpEmail.match(emailPattern) !== null &&
      (!this.props?.data?.siteData?.site?.login_captcha_key ||
        this.state.isCaptchaSelected)
    ) {
      //api call
      let signupReq = {
        email: this.state.signUpEmail,
        bounz_register: this.state.bounz_register,
      };
      signup(signupReq).then((res) => {
        if (res && res.status === true && res.message !== "") {
          this.setState({ activationLink: true, signUpEmailErr: "" });
          if (
            typeof this?.props?.data?.clearDirectOpenLinkPopup === "function"
          ) {
            this.props.data.clearDirectOpenLinkPopup();
          }
          getCountriesList().then((resp) => {
            let countryList = [];
            if (resp?.data?.length > 0) {
              resp?.data.map((item) => {
                countryList.push({
                  ...item,
                  value: item.contry_name,
                  isdCode: item.contry_isd,
                  countryCode: item.contry_code,
                  flag: item.contry_flag,
                  countryFlag: item.contry_flag,
                  countryName: item.contry_name,
                });
              });
            }
            this.setState({ originCountries: countryList });
          });
          this.setState({
            popupType: "SignUp",
            isPasswordRequired: true,
            registrationToken: res.registration_token,
            signupForm: {
              ...this.state.signupForm,
              email: this.state.signUpEmail,
            },
          });
        } else {
          //    this.setState({ activationLink: false, signUpEmailErr: typeof res.message === "string" ? res.message : "" });
          this.setState({
            activationLink: false,
            signUpEmailErr:
              typeof res.message === "string"
                ? res.message
                : res.message && res.message.length > 0
                ? res.message[0].msg
                : "some thing went wrong",
          });
        }
      });
    } else {
      this.setState({
        activationLink: false,
        captchErrorMsg: !this.state.isCaptchaSelected
          ? "Please Select Captcha"
          : "",
      });
    }
  }; //ended here

  //Forgot pass
  onChangeForgotPassEmail = (e) => {
    this.setState({
      forgotPasswordEmail: e.target.value,
      forgotPasswordErr: "",
    });
  };

  onClickForgotSubimitBtn = () => {
    this.setState({
      forgotPasswordErr:
        this.state.forgotPasswordEmail === ""
          ? errorsList.email.ERE101
          : this.state.forgotPasswordEmail.match(emailPattern) !== null
          ? ""
          : errorsList.email.ERE102,
    });
    if (
      this.state.forgotPasswordEmail !== "" &&
      this.state.forgotPasswordEmail.match(emailPattern) !== null
    ) {
      //api call
      let forgotPassReq = {
        email: this.state.forgotPasswordEmail,
      };
      forgotpassword(forgotPassReq).then((res) => {
        // console.log('forgot pass in common', res);
        if (res && res.status === true && res.message && res.message !== "") {
          this.setState({ forgotPassText: true, forgotPasswordErr: "" });
        } else {
          this.setState({
            forgotPassText: false,
            forgotPasswordErr: res.message,
          });
        }
      });
    } else {
      this.setState({ forgotPassText: false });
    }
  };

  //send otp popup
  onClickSendOTP = () => {
    this.setState({
      loginOTPEmailErr:
        this.state.loginWithOTPEmail === ""
          ? errorsList.email.ERE101
          : this.state.loginWithOTPEmail.match(emailPattern) !== null
          ? ""
          : errorsList.email.ERE102,
    });
    if (
      this.state.loginWithOTPEmail !== "" &&
      this.state.loginWithOTPEmail.match(emailPattern) !== null
    ) {
      //api call
      // setPopupType("VerifyOTP")
      this.setState({ popupType: "VerifyOTP" });
    }
  };

  onChangeLoginOTPEmail = (e) => {
    this.setState({ loginWithOTPEmail: e.target.value, loginOTPEmailErr: "" });
  };

  onChangeEmailOTP = (e) => {
    setLoginWithOTPEmail({
      loginWithOTPEmail: e.target.value,
      loginOTPEmailErr: "",
    });
  };

  onClickResendOTP = () => {
    //api call
  };

  //verify otp
  onChangeVerifyOTP = (e) => {
    this.setState({ verifyOTPEmail: e.target.value, verifyOTPEmailErr: "" });
  };

  onOTPLogin = () => {
    this.setState({
      verifyOTPEmailErr:
        this.state.verifyOTPEmail === ""
          ? errorsList.OTP.EROTP101
          : this.state.verifyOTPEmail.match(otpregex) !== null
          ? ""
          : errorsList.OTP.EROTP102,
    });
    if (
      this.state.verifyOTPEmail !== "" &&
      this.state.verifyOTPEmail.match(otpregex) !== null
    ) {
      //api call
    }
  };

  onClickConfirmbtn = () => {
    this.setState({
      passwordObjErr: {
        ...this.state.passwordObjErr,
        newPassword:
          this.state.passwordObj.newPassword === ""
            ? errorsList.password.ERP104
            : this.state.passwordObj.newPassword.match(pwsEx) !== null
            ? ""
            : errorsList.password.ERP106,
        confirmPassword:
          this.state.passwordObj.confirmPassword === ""
            ? errorsList.confirmPassword.ERP102
            : this.state.passwordObj.confirmPassword ===
              this.state.passwordObj.newPassword
            ? ""
            : errorsList.confirmPassword.ERP103,
      },
    });
    if (
      this.state.passwordObj.newPassword !== "" &&
      this.state.passwordObj.confirmPassword !== "" &&
      this.state.passwordObj.newPassword.match(pwsEx) !== null &&
      this.state.passwordObj.confirmPassword ===
        this.state.passwordObj.newPassword
    ) {
      let changePassReq = {
        confirm_password: this.state.passwordObj.confirmPassword,
        new_password: this.state.passwordObj.newPassword,
        resettoken: this.props.data.resetToken,
      };
      changepassword(changePassReq).then((res) => {
        console.log("change pass response", res);
        if (res && res.status === true) {
          this.props.data.clearDirectOpenLinkPopup();
          this.setState({
            popupType: "PasswordUpdatedSuccessfully",
            changePasswordAPIErr: "",
          });
        } else {
          this.setState({ changePasswordAPIErr: res.message });
        }
      });
    }
  };

  //signup form
  onChangeSignFName = (e) => {
    let uppercase =
      e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    if (e.target.value.charCodeAt(0) !== 32) {
      this.setState({
        signupForm: { ...this.state.signupForm, firstName: uppercase },
        signupFormErr: { ...this.state.signupFormErr, firstName: "" },
      });
    }
  };

  onChangeSignLName = (e) => {
    let uppercase =
      e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    if (e.target.value.charCodeAt(0) !== 32) {
      this.setState({
        signupForm: { ...this.state.signupForm, lastName: uppercase },
        signupFormErr: { ...this.state.signupFormErr, lastName: "" },
      });
    }
  };

  onChangeSignMobile = (e) => {
    var pat = /^[0-9]*$/;
    var str = e.target.value;
    if (pat.test(str)) {
      this.setState({
        signupForm: { ...this.state.signupForm, mobileNo: str },
        signupFormErr: { ...this.state.signupFormErr, mobileNo: "" },
      });
    }
  };

  onChangeSignEmail = (e) => {
    this.setState({
      signupForm: {
        ...this.state.signupForm,
        email: e.target.value.replace(/\s/g, ""),
      },
      signupFormErr: { ...this.state.signupFormErr, email: "" },
    });
  };

  onChangeSignPassword = (e) => {
    let spaceEX = new RegExp(/(^\S*$)/);
    let confpwsEx = new RegExp(/^(?=.{0,13}$).*/);
    if (e.target.value.match(confpwsEx) && e.target.value.match(spaceEX)) {
      this.setState({
        signupForm: { ...this.state.signupForm, password: e.target.value },
        signupFormErr: { ...this.state.signupFormErr, password: "" },
      });
    } else {
      this.setState({
        signupFormErr: {
          ...this.state.signupFormErr,
          password: "Please Enter Valid Password",
        },
      });
    }
  };

  onChangeSignCnfPassword = (e) => {
    let spaceEX = new RegExp(/(^\S*$)/);
    let confpwsEx = new RegExp(/^(?=.{0,13}$).*/);
    if (e.target.value.match(confpwsEx) && e.target.value.match(spaceEX)) {
      this.setState({
        signupForm: {
          ...this.state.signupForm,
          confirmPassword: e.target.value,
        },
        signupFormErr: { ...this.state.signupFormErr, confirmPassword: "" },
      });
    } else {
      this.setState({
        signupFormErr: {
          ...this.state.signupFormErr,
          confirmPassword: "Please Enter Valid Password",
        },
      });
    }
  };

  finalSignupClick = () => {
    this.setState({
      signupFormErr: {
        ...this.state.signupFormErr,
        email:
          this.state.signupForm.email === "" ||
          this.state.signupForm.email === undefined
            ? errorsList.email.ERE101
            : this.state.signupForm.email.match(emailPattern) !== null
            ? ""
            : errorsList.email.ERE102,
        firstName:
          this.state.signupForm.firstName === "" ||
          this.state.signupForm.firstName === undefined
            ? errorsList.firstName.ERFN101
            : "",
        lastName:
          this.state.signupForm.lastName === "" ||
          this.state.signupForm.lastName === undefined
            ? errorsList.lastName.ERLN101
            : "",
        mobileNo:
          this.state.signupForm.mobileNo === "" ||
          this.state.signupForm.mobileNo === undefined
            ? errorsList.mobileNo.ERMN102
            : this.state.signupForm.mobileNo.toString().length < 4 ||
              this.state.signupForm.mobileNo.toString().length > 22
            ? errorsList.mobileNo.ERMN101
            : "",
        countryCode:
          this.state.signupForm.countryCode === "" ||
          this.state.signupForm.countryCode === undefined
            ? errorsList.countryCode.ERCC101
            : "",
        nationality:
          this.state.signupForm.nationality === "" ||
          this.state.signupForm.nationality === undefined
            ? errorsList.nationality.ERNT101
            : "",
        password: this.state.isPasswordRequired
          ? this.state.signupForm.password === ""
            ? errorsList.password.ERP104
            : // (this.state.signupForm.password.length !== this.props.data.siteData.site.min_password_length) ? `Password length must be ${this.props.data.siteData.site.min_password_length}`: ""
            this.state.signupForm.password.match(pwsEx) !== null
            ? ""
            : errorsList.password.ERP106
          : "",
        confirmPassword: this.state.isPasswordRequired
          ? this.state.signupForm.confirmPassword === ""
            ? errorsList.confirmPassword.ERP102
            : this.state.signupForm.confirmPassword ===
              this.state.signupForm.password
            ? ""
            : errorsList.confirmPassword.ERP103
          : "",
      },
    });
    if (
      this.state.signupForm.email !== "" &&
      this.state.signupForm.firstName !== "" &&
      this.state.signupForm.lastName !== "" &&
      this.state.signupForm.mobileNo !== "" &&
      this.state.signupForm.mobileNo !== "" &&
      this.state.signupForm.mobileNo !== undefined &&
      this.state.signupForm.countryCode !== "" &&
      (!this.state.isPasswordRequired ||
        (this.state.signupForm.password !== "" &&
          this.state.signupForm.confirmPassword !== "" &&
          this.state.signupForm.password.match(pwsEx) !== null &&
          this.state.signupForm.confirmPassword ===
            this.state.signupForm.password))
    ) {
      let signupReq = {
        first_name: this.state.signupForm.firstName,
        last_name: this.state.signupForm.lastName,
        // "password": this.state.signupForm.password,
        country_code: this.state.selectedCountry,
        mobile_number: this.state.signupForm.mobileNo,

        // "nationality": this.state.signupForm.nationality,
        // "country":this.state.signupForm.nationality,
        registraion_token:
          this.props?.data?.registrationToken || this.state.registrationToken,
        isNormalLogin: this.state.isPasswordRequired,
      };
      if (this.state.isPasswordRequired) {
        signupReq["password"] = this.state.signupForm.password || "";
      }
      //console.log("request", signupReq);
      register(signupReq).then((res) => {
        console.log("res register", res);
        if (res && res.status === true && res.message && res.message !== "") {
          // alert('you have registered successfully on Site');
          this.setState({ registerAPIErr: "" });
          // this.props.history.push('/');
          window.location.href = "/";
        } else {
          this.setState({ registerAPIErr: res.message });
        }
      });
    }
  };

  onContinueClickHandler = () => {
    window.location.reload(); /* = '/' */
  };

  //captch signup
  onchangesigninWithCaptchaMail = (e) => {
    this.setState({
      signUpWithCaptchaMail: e.target.value,
      signUpWithCaptchaMailErr: "",
    });
  };

  onClickCaptchaSignupbtn = () => {
    this.setState({
      signUpWithCaptchaMailErr:
        this.state.signUpWithCaptchaMail === ""
          ? errorsList.email.ERE101
          : this.state.signUpWithCaptchaMail.match(emailPattern) !== null
          ? ""
          : errorsList.email.ERE102,
    });
    if (
      this.state.signUpWithCaptchaMail !== "" &&
      this.state.signUpWithCaptchaMail.match(emailPattern) !== null
    ) {
      //api call
      let signupReq = {
        email: this.state.signUpWithCaptchaMail,
      };
      signup(signupReq).then((res) => {
        if (res && res.status === true && res.message !== "") {
          this.setState({ activationLink: true, signUpWithCaptchaMailErr: "" });
        } else {
          this.setState({
            activationLink: false,
            signUpWithCaptchaMailErr: res.message,
          });
        }
      });
    } else {
      this.setState({ activationLink: false });
    }
  };

  /**Start of new traveller dropdown added for customisation */
  onClickInputCountryTraveller = () => {
    this.setState({
      selectedCountry: { countryFlag: "" },
      searchCountryText: this.state.searchCountryText,
      signupForm: { ...this.state.signupForm, countryCode: "" },
      signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
    });
  };

  onKeyDownCountryCodeTraveller = (e) => {
    this.setState({
      searchCountryText: "",
      signupForm: { ...this.state.signupForm, countryCode: "" },
      signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
      selectedCountry: { countryFlag: "/images/user-active.png" },
    });
  };

  selectCountryCodeFunctionTraveller = (ele) => {
    var numberPat = /^[0-9]*$/;
    if (numberPat.test(+ele.isdCode)) {
      this.setState({
        searchCountryText: "+" + ele.isdCode,
        selectedCountry: ele,
        signupForm: {
          ...this.state.signupForm,
          countryCode: "+" + ele.isdCode,
        },
        signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
      });
    } else {
      this.setState({
        searchCountryText: ele.isdCode,
        selectedCountry: ele,
        signupForm: { ...this.state.signupForm, countryCode: ele.isdCode },
        signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
      });
    }
  };

  onChangeInputCountryCodeFunctionTraveller = (value) => {
    var numberPat = /^[0-9]*$/;
    if (typeof value === "number") {
      let val22 = value.toString().includes("+")
        ? value.toString().split("+")[1]
        : value; //.includes('+') ? value.split('+')[1] : value;
      if (val22 !== "") {
        this.setState({
          searchCountryText: "+" + val22,
          signupForm: { ...this.state.signupForm, countryCode: "+" + val22 },
          signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
        });
      }
    } else if (typeof value === "string") {
      let val22 = value.includes("+") ? value.split("+")[1] : value; //.includes('+') ? value.split('+')[1] : value;
      if (typeof val22 === "number") {
        this.setState({
          searchCountryText: "+" + val22,
          signupForm: { ...this.state.signupForm, countryCode: "+" + val22 },
          signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
        });
      } else {
        let val22 = value;
        if (val22 !== "") {
          this.setState({
            searchCountryText: val22,
            signupForm: { ...this.state.signupForm, countryCode: val22 },
            signupFormErr: { ...this.state.signupFormErr, countryCode: "" },
          });
        }
      }
    }
  };
  /**End of new traveller dropdown added for customisation */

  /** start of nationality */
  onClickNationalityHandler = (params) => {
    this.setState({
      selectedNationality: params,
      signupForm: { ...this.state.signupForm, nationality: params.value },
      signupFormErr: { ...this.state.signupFormErr, nationality: "" },
    });
  };

  onChangeInputNationality = (params) => {
    this.setState({
      selectedNationality: { flag: "/images/ax-tick.svg" },
      signupForm: {
        ...this.state.signupForm,
        nationality: params.target.value,
      },
    });
  };

  setCaptchDataCallBack = (bool, errorMsg) => {
    this.setState({ isCaptchaSelected: bool, captchErrorMsg: errorMsg });
  };

  onClosePopup = () => {
    if (this.state.isSuccessPopupVisible) {
      window.location.reload(); /* = '/' */
    } else {
      this.props.data.onClickCross();
    }
  };
  getSignUpForm = (data, type) => {
    console.log(data);
    if (typeof this?.props?.data?.clearDirectOpenLinkPopup === "function") {
      this.props.data.clearDirectOpenLinkPopup();
    }
    this.setState({
      popupType: "SignUp",
      isPasswordRequired: false,
      registrationToken: data.registration_token,
      signupForm: {
        ...this.state.signupForm,
        email: data.email,
        firstName: data?.first_name || "",
      },
    });
  };

  renderLoginPopup = (popup) => {
    console.log("🚀 ~ file: indexBackup.js:900 ~ Theme1 ~ popup:", popup);

    let styles = this.props.data.logincss;
    switch (popup) {
      case "LogIn":
        return (
          <>
            {/* <div className={styles.personal_login_text}>
                        <div className={this.state.toggleAgentLogin ? "" : styles.personal_login_tab_active} onClick={() => { this.setState({ toggleAgentLogin: false }) }}><span>Personal Login</span></div>
                    </div> */}
            {/* <div className={!this.state.toggleAgentLogin ? "" : styles.personal_login_tab_active} onClick={() => { this.setState({ toggleAgentLogin: true }) }}><span>AGENT LOGIN</span></div> */}

            {this.state.toggleAgentLogin ? (
              <>
                <div className="flex justify-between items-center">
                  <div className={styles.login_by_mail_id_text}>Login</div>
                  <div className="flex flex-col justify-center items-center">
                    <div className={"!m-0 " + styles.noaccount}>
                      Don't have an account{" "}
                      <span
                        onClick={() => {
                          this.setState({ popupType: "BeforeSignUp" });
                        }}
                      >
                        Sign Up
                      </span>
                    </div>
                  </div>
                </div>
                <input
                  className={styles.email_id}
                  id="email"
                  autoComplete="off"
                  type="email"
                  placeholder="Email Id"
                  maxLength="50"
                  value={this.state.logincred.email}
                  onChange={this.onChangeLoginEmail}
                />
                {this.state.loginErrors.email !== "" ? (
                  <div className={styles.email_error_msg}>
                    {this.state.loginErrors.email}
                  </div>
                ) : (
                  ""
                )}
                <input
                  className={styles.email_id}
                  id="password"
                  type="password"
                  autoComplete="new-password"
                  placeholder="Password"
                  maxLength="50"
                  onChange={this.onChangeLoginPassword}
                />
                {this.state.loginErrors.password !== "" ? (
                  <div className={styles.email_error_msg}>
                    {this.state.loginErrors.password}
                  </div>
                ) : (
                  ""
                )}
                {this.state.loginErrorMsg && (
                  <div className={styles.email_error_msg}>
                    {this.state.loginErrorMsg}
                  </div>
                )}
                <div
                  className={styles.forgot_password}
                  onClick={() => {
                    this.props.data.clearDirectOpenLinkPopup();
                    this.setState({
                      popupType: "ForgotPassword",
                      forgotPasswordEmail: this.state.logincred.email,
                    });
                  }}
                >
                  Forgot Password?
                </div>
                <button
                  className={styles.btn_login}
                  onClick={this.onClickLoginBtn}
                >
                  {this.state.onClickLoginLoader ? "" : "Login"}
                </button>
                {this.state.onClickLoginLoader && (
                  <div className={styles.login_loader} />
                )}
              </>
            ) : (
              <>
                <div className={styles.login_flex}>
                  <div className={styles.login_banner}>
                    {/* <img src="/images/login_banner.png" alt="login" />
                     */}

                    {this.props?.data?.siteData?.data?.signin?.upload_image ? (
                      <img
                        src={`/shared/api/media/${this.props?.data?.siteData?.data?.signin?.upload_image}`}
                        alt="Uploaded Image"
                      />
                    ) : (
                      <img src="/images/login_banner.png" alt="Default Image" />
                    )}
                  </div>
                  <div className={styles.form_flex}>
                    <div className="flex justify-between mb-2">
                      <div className={styles.heading_text_div}>
                        <svg
                          onClick={() => {
                            this.props.data.onClickCross();
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="24"
                        >
                          <path
                            fill-rule="evenodd"
                            fill="#FFF"
                            d="m14.442 3.241-8.834 8.747 8.837 8.749a1.893 1.893 0 0 1 0 2.695 1.938 1.938 0 0 1-2.721 0L1.536 13.343a1.878 1.878 0 0 1-.529-.99 1.887 1.887 0 0 1 .526-1.718L11.721.547a1.938 1.938 0 0 1 2.721 0 1.89 1.89 0 0 1 0 2.694z"
                          />
                        </svg>
                        <div className={styles.login_by_mail_id_text}>
                          Sign In
                          <br /> to Company
                        </div>
                        {/* <div className='flex flex-col justify-center items-center'>
                                    <span className={styles.new}>New</span>
                                    <button className={styles.viaotp} onClick={() => { this.setState({ popupType: "LoginViaOTP" }) }}>Login With OTP</button>
                                </div> */}
                      </div>
                      {/* <div className='flex flex-col justify-center items-center'>
                                    <span className={styles.new}>New</span>
                                    <button className={styles.viaotp} onClick={() => { this.setState({ popupType: "LoginViaOTP" }) }}>Login With OTP</button>
                                </div> */}
                    </div>
                    <div className={styles.zenith_signin}>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <div className={styles.zenith_input}>
                          <label>Email ID</label>
                          <input
                            className={styles.email_id}
                            id="email"
                            autoComplete="off"
                            type="email"
                            placeholder="Enter Email ID"
                            maxLength="50"
                            value={this.state.logincred.email}
                            onChange={this.onChangeLoginEmail}
                            onBlur={this.checkregisterstatus}
                          />
                          {this.state.loginErrors.email !== "" ? (
                            <div className={styles.email_error_msg}>
                              {this.state.loginErrors.email}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className={styles.zenith_input}>
                          <label>Password</label>
                          <input
                            tabindex="0"
                            className={styles.email_id}
                            id="pass"
                            type="password"
                            placeholder="Enter Password"
                            autoComplete="new-password"
                            maxLength="50"
                            onChange={this.onChangeLoginPassword}
                            onClick={() => {
                              this.setState({ isReadOnly: false });
                            }}
                            onBlur={() => {
                              this.setState({ isReadOnly: true });
                            }}
                          />
                          {this.state.loginErrorMsg !== "" ? (
                            ""
                          ) : this.state.loginErrors.password !== "" ? (
                            <div className={styles.email_error_msg}>
                              {this.state.loginErrors.password}
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.loginErrorMsg !== "" ? (
                            <div className={styles.email_error_msg}>
                              {this.state.loginErrorMsg}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>
                          <span
                            className={styles.forgot_password}
                            onClick={() => {
                              this.props.data.clearDirectOpenLinkPopup();
                              this.setState({
                                popupType: "ForgotPassword",
                                forgotPasswordEmail: this.state.logincred.email,
                              });
                            }}
                          >
                            Forgot Password?
                          </span>
                        </div>
                        <button
                          type="submit"
                          className={styles.btn_login}
                          onClick={this.onClickLoginBtn}
                        >
                          {this.state.onClickLoginLoader ? "" : "Sign In"}
                        </button>
                        {/* {this.state.onClickLoginLoader && (
                          <div className={styles.login_loader} />
                        )}
                        <div className={styles.or_login_with}>OR</div>
                        <FacebookGoogleLogin
                          getSignUpForm={this.getSignUpForm}
                          siteData={this.props.data.siteData}
                          styles={styles}
                        />*/}
                        <div className={styles.noaccount}>
                          Don't have an account{" "}
                          <span
                            onClick={() => {
                              this.props.data.clearDirectOpenLinkPopup();
                              this.setState({ popupType: "BeforeSignUp" });
                            }}
                          >
                            Sign Up
                          </span>
                        </div>
                      </form>
                      {/* <div className={styles.policytext}>
                        By logging in, I understand &amp; agree to Zenith
                        Holidays
                        <span
                          onClick={() => {
                            window.open(
                              `${window.location.origin}/terms-of-use`,
                              "_blank"
                            );
                          }}
                        >
                          {" "}
                          Terms of use
                        </span>{" "}
                        and
                        <span
                          onClick={() => {
                            window.open(
                              `${window.location.origin}/privacy-policy`,
                              "_blank"
                            );
                          }}
                        >
                          {" "}
                          Privacy Policy
                        </span>
                      </div> */}
                    </div>

                    {/* <div onClick={() => { this.setState({ popupType: "ChangePassword" }) }}>Change Password</div>
                            <div onClick={() => { this.setState({ popupType: "SignUpWithCaptcha" }) }}>Sign Up With Captcha</div>
                            <div onClick={() => { this.setState({ popupType: "SignUp" }) }}>Sign Up</div> */}

                    {/* <div className={styles.policytext}>
                      This site is protected by reCAPTCHA and the Google
                      <span
                        onClick={() => {
                          window.open(
                            `${window.location.origin}/page/privacypolicy`,
                            "_blank"
                          );
                        }}
                      >
                        {" "}
                        Privacy Policy
                      </span>{" "}
                      and
                      <span
                        onClick={() => {
                          window.open(
                            `${window.location.origin}/page/termsofuse`,
                            "_blank"
                          );
                        }}
                      >
                        {" "}
                        Terms or Service
                      </span>{" "}
                      apply.
                      <span onClick={() => { window.open(`${window.location.origin}/tnc`, '_blank') }}> T&Cs</span>
                    </div> */}
                  </div>
                </div>
              </>
            )}
          </>
        );
      case "BeforeSignUp":
        return (
          <>
            <div className={styles.login_flex}>
              <div className={styles.login_banner}>
                {/* <img src="/images/login_banner.png" alt="login" /> */}
                {this.props?.data?.siteData?.data?.signin?.upload_image ? (
                  <img
                    src={`/shared/api/media/${this.props?.data?.siteData?.data?.signin?.upload_image}`}
                    alt="Uploaded Image"
                  />
                ) : (
                  <img src="/images/login_banner.png" alt="Default Image" />
                )}
              </div>
              <div className={styles.form_flex}>
                <div className={styles.heading_text_div}>
                  <svg
                    onClick={() => {
                      this.props.data.clearDirectOpenLinkPopup();
                      this.setState({ popupType: "LogIn" });
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="24"
                  >
                    <path
                      fill-rule="evenodd"
                      fill="#FFF"
                      d="m14.442 3.241-8.834 8.747 8.837 8.749a1.893 1.893 0 0 1 0 2.695 1.938 1.938 0 0 1-2.721 0L1.536 13.343a1.878 1.878 0 0 1-.529-.99 1.887 1.887 0 0 1 .526-1.718L11.721.547a1.938 1.938 0 0 1 2.721 0 1.89 1.89 0 0 1 0 2.694z"
                    />
                  </svg>
                  <div className={styles.login_by_mail_id_text}>Sign Up</div>
                </div>
                <div className={styles.zenith_signin}>
                  <div
                    className={`${styles.zenith_input} ${styles.signup_email}`}
                  >
                    <label>Email ID</label>
                    <input
                      className={styles.email_id}
                      id="email"
                      type="text"
                      autoComplete="off"
                      placeholder="Enter  Email ID"
                      value={this.state.signUpEmail}
                      maxLength="50"
                      onChange={this.onChangeSignupEmailId}
                    />
                    {this.state.signUpEmailErr !== "" ? (
                      <div className={styles.email_error_msg}>
                        {this.state.signUpEmailErr}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {this.props?.data?.siteData?.site?.login_captcha_key !== "" &&
                    this.props?.data?.siteData?.site?.login_captcha_key !==
                      undefined && (
                      <CaptchaComponent
                        errorMsg={this.state.captchErrorMsg}
                        setCaptchDataCallback={this.setCaptchDataCallBack}
                        siteData={this.props.data.siteData}
                      />
                    )}
                  {/* <div style={{ marginTop: "10px" }}>
                        <input className="" id="bounz_register" type="checkbox" style={{ marginRight: "9px" }} checked={this.state.bounz_register} onChange={(e) => this.onChangeBounzCheck(e.target.checked)} />
                        I accept that my details will be sent to create a new account     
                    </div> */}
                  <button
                    className={styles.btn_login}
                    onClick={() => this.onClickSignupBtn()}
                  >
                    Sign Up
                  </button>
                  {/* <div className={styles.or_login_with}>OR</div>
                  {this.state.activationLink && (
                    <div className={styles.cong_text}>
                      <span>Congratulations</span> have send activation link on{" "}
                      {this.state.signUpEmail}
                    </div>
                  )}
                  <FacebookGoogleLogin
                    isSignUp={true}
                    getSignUpForm={this.getSignUpForm}
                    signupText={"SignUp"}
                    siteData={this.props.data.siteData}
                    styles={styles}
                  /> */}
                  <div className={styles.noaccount}>
                    Already have an account{" "}
                    <span
                      onClick={() => {
                        this.props.data.clearDirectOpenLinkPopup();
                        this.setState({ popupType: "LogIn" });
                      }}
                    >
                      Login
                    </span>
                  </div>
                </div>
                {/* <div className={styles.policytext}>By proceeding, you agree to Elevate Trips <span onClick={() => { window.open(`${window.location.origin}/Privacy_policy`, '_blank') }}> Privacy Policy</span>, <span onClick={() => { window.open(`${window.location.origin}/page/termsofuse`, '_blank') }}>User Agreement</span> and <span onClick={() => { window.open(`${window.location.origin}/tnc`, '_blank') }}>T&Cs</span></div> */}
              </div>
            </div>
          </>
        );
      case "SignUpWithCaptcha":
        return (
          <>
            <div className={styles.personal_login_text}>
              <div
                className={
                  this.state.toggleAgentLogin
                    ? ""
                    : styles.personal_login_tab_active
                }
                onClick={() => {
                  this.setState({ toggleAgentLogin: false });
                }}
              >
                <span>PERSONAL LOGIN</span>
              </div>
              <div
                className={
                  !this.state.toggleAgentLogin
                    ? ""
                    : styles.personal_login_tab_active
                }
                onClick={() => {
                  this.setState({ toggleAgentLogin: true });
                }}
              >
                <span>AGENT LOGIN</span>
              </div>
            </div>
            <div className="mb-2">
              <div className={styles.login_by_mail_id_text}>Sign Up</div>
            </div>
            <div className={styles.zenith_input}>
              <label> Email ID</label>
              <input
                className={styles.email_id}
                id="email"
                autocomplete={false}
                type="email"
                placeholder="Enter Email ID"
                value={this.state.signUpWithCaptchaMail}
                maxLength="50"
                onChange={this.onchangesigninWithCaptchaMail}
              />
              {this.state.signUpWithCaptchaMailErr !== "" ? (
                <div className={styles.email_error_msg}>
                  {this.state.signUpWithCaptchaMailErr}
                </div>
              ) : (
                ""
              )}
            </div>
            {this.props.data.siteData.site.login_captcha_key !== "" && (
              <CaptchaComponent
                errorMsg={this.state.captchErrorMsg}
                setCaptchDataCallback={this.setCaptchDataCallBack}
                siteData={this.props.data.siteData}
              />
            )}
            <button
              className={styles.btn_login + " !mb-0"}
              onClick={this.onClickCaptchaSignupbtn}
            >
              Sign Up
            </button>
            {this.state.activationLink && (
              <div className={styles.cong_text}>
                <span>Congratulations</span> have send activation link on{" "}
                {this.state.signUpWithCaptchaMail}
              </div>
            )}
            <div className={styles.or_login_with}>Sign Up With</div>
            <FacebookGoogleLogin
              getSignUpForm={this.getSignUpForm}
              signupText={"SignUp"}
              siteData={this.props.data.siteData}
            />
            <div className={styles.noaccount}>
              Don't have an account{" "}
              <span
                onClick={() => {
                  this.setState({ popupType: "LogIn" });
                }}
              >
                Login
              </span>
            </div>
            {/* <div className={styles.policytext}>By proceeding, you agree to Elevate Trips <span onClick={() => { window.open(`${window.location.origin}/Privacy_policy`, '_blank') }}> Privacy Policy</span>, <span onClick={() => { window.open(`${window.location.origin}/page/termsofuse`, '_blank') }}>User Agreement</span> and <span onClick={() => { window.open(`${window.location.origin}/Terms_and_Conditions`, '_blank') }}>T&Cs</span></div> */}
            <div className="align-center">
              <img
                src={"/images/bounz_big.png"}
                alt={"BOUNZ"}
                height="40px"
                width="80px"
                className="object-scale-down mx-auto my-4"
              />
            </div>
            <div className={styles.accept_policy}>
              <label className={styles.checkbox_common}>
                <input
                  type="checkbox"
                  id=""
                  name="accept-checkbox"
                  value="BOUNZ"
                />
                <span className={styles.checkmark}></span>
              </label>
              <label for="accept-checkbox">
                {" "}
                I accept that my details will be sent to BOUNZ to create a new
                account or link with an existing account
              </label>
            </div>
          </>
        );
      case "SignUp":
        return (
          <>
            <div className={styles.singup_header}>
              <div className={styles.approved_sec_mob}>
                <svg
                  onClick={() => {
                    this.props.data.onClickCross();
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="24"
                >
                  <path
                    fill-rule="evenodd"
                    fill="#FFF"
                    d="m14.442 3.241-8.834 8.747 8.837 8.749a1.893 1.893 0 0 1 0 2.695 1.938 1.938 0 0 1-2.721 0L1.536 13.343a1.878 1.878 0 0 1-.529-.99 1.887 1.887 0 0 1 .526-1.718L11.721.547a1.938 1.938 0 0 1 2.721 0 1.89 1.89 0 0 1 0 2.694z"
                  />
                </svg>
                <p>Account Created Successfully</p>
              </div>
              <div className={styles.approved_sec}>
                <h1>
                  <img src="images/refundable.svg" alt="refund" />
                  Congratulations
                </h1>
                <p>Account Created Successfully</p>
              </div>
              {/* <div className={styles.welcome_zenith}>
                <div className={styles.mobicon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="38"
                    height="38"
                  >
                    <defs>
                      <filter id="3jf4uftzpa">
                        <feFlood
                          flood-color="#FFF"
                          flood-opacity="1"
                          result="floodOut"
                        ></feFlood>
                        <feComposite
                          operator="atop"
                          in="floodOut"
                          in2="SourceGraphic"
                          result="compOut"
                        ></feComposite>
                        <feBlend in="compOut" in2="SourceGraphic"></feBlend>
                      </filter>
                    </defs>
                    <g filter="url(#3jf4uftzpa)">
                      <path
                        fill-rule="evenodd"
                        fill="#97144D"
                        d="M37.903 16.332c-.819 1.136-2.132 1.99-3.356 2.755.962.703 1.929 1.384 2.969 1.995.515.302.359 1.004-.157 1.192a103.1 103.1 0 0 1-2.359.835c-.363.123-.738.275-1.118.389.822.988 1.473 2.232 2.144 3.253.261.396-.081.941-.541.934-1.333-.019-2.761.068-4.115-.074l.03.405c.139.472.252.956.398 1.423.263.842.589 1.657.911 2.477.159.404-.328.885-.735.729-.88-.337-1.762-.67-2.64-1.014-.463-.181-.956-.368-1.415-.602.015 1.569-.19 3.159-.443 4.698a.47.47 0 0 1-.127.235c-.056.146-.15.276-.32.324-.956.269-2.114-.84-2.782-1.43a11.92 11.92 0 0 1-.889-.884 59.425 59.425 0 0 1-1.502 3.401c-.216.446-.824.344-1.065 0a93.154 93.154 0 0 1-1.52-2.265c-.191-.292-.395-.585-.584-.885-.704 1.205-1.591 2.355-2.397 3.485-.299.419-.999.403-1.147-.149-.347-1.287-.889-2.59-1.205-3.901-.498.306-1.051.558-1.52.881-.704.485-1.292 1.11-2.141 1.325-.341.086-.777-.173-.742-.56.127-1.424.091-2.929.295-4.359-.325.113-.665.196-.916.29l-2.616.976c-.46.172-.866-.335-.76-.752.308-1.206.576-2.422.874-3.629-1.324-.043-2.648-.087-3.974-.089-.442 0-.8-.527-.531-.917.767-1.115 1.465-2.29 2.269-3.382-.452-.178-.897-.385-1.342-.551a53.331 53.331 0 0 0-2.396-.827c-.516-.166-.552-.78-.142-1.078 1.025-.747 1.997-1.557 2.99-2.344-.979-.695-1.954-1.395-2.962-2.05-.397-.258-.458-.886 0-1.13a37.504 37.504 0 0 1 2.797-1.354c.371-.159.75-.342 1.139-.487-.889-1.003-1.653-2.157-2.353-3.238-.293-.454.191-.947.661-.852 1.335.27 2.662.369 4.006.467-.482-1.354-.781-2.781-1.118-4.17-.096-.399.285-.891.731-.724 1.139.428 2.295.838 3.437 1.275-.061-.48-.064-.981-.092-1.358-.074-.995-.206-2.079.207-3.01.148-.335.653-.345.884-.113a58.046 58.046 0 0 0 2.073 1.988c.289.262.602.514.91.77.625-1.381 1.231-2.752 1.678-4.206.129-.418.681-.593 1.002-.262.831.856 1.781 1.824 2.518 2.869.623-1.024 1.543-1.98 2.247-2.882.284-.363.823-.103.948.248.464 1.31.933 2.626 1.359 3.952 1.164-.963 2.398-1.857 3.626-2.731.364-.259.807.096.829.471a24.956 24.956 0 0 1-.107 3.99l.274-.071a31.587 31.587 0 0 1 1.623-.526c.65-.19 1.924-.812 2.604-.516.725.315.404 1.135.218 1.673-.362 1.05-.715 2.109-1.114 3.147.047-.001.092-.007.142.002.657.128 1.398-.011 2.063-.045.704-.036 1.41-.057 2.115-.084.383-.015.731.488.474.819-.774 1.001-1.529 2.182-2.431 3.124 1.382.284 2.958 1.126 3.999 1.833.264.18.442.577.23.871zm-25.645-4.321c-3.036 1.03-3.259 4.978-1.021 6.953.309.273.614.462.915.607 2.402.044 4.964-.734 5.508-3.438.651-3.241-2.58-5.079-5.402-4.122zm9.868-.471c-2.925 4.919-5.683 9.852-9.292 14.382.4-.053.805-.079 1.186-.11.647-.053 1.311-.099 1.968-.079 1.985-4.835 4.601-9.999 7.753-14.332-.539.061-1.076.108-1.615.139zm5.679 8.582c-1.249-2.534-4.721-3.02-6.654-.934-1.716 1.852-1.317 4.502.298 6.131.68.416 1.537.571 2.506.5 2.794-.207 5.201-2.957 3.85-5.697zM23.56 23.44c-.45-.165-.778-.519-.973-.932-.017-.025-.04-.043-.056-.07-.288-.497-.229-1.042.036-1.477l.001-.004c.177-.352.493-.606.827-.698l.007-.003c.031-.008.06-.018.09-.024.093-.03.185-.06.284-.074 1.099-.151 2.246.711 2.138 1.864-.106 1.133-1.306 1.802-2.354 1.418zm-11.068-6.576c-.605-.509-.763-1.482-.243-2.106a1.39 1.39 0 0 1 .347-.286 1.428 1.428 0 0 1 1.931-.089c1.577 1.306-.461 3.805-2.035 2.481z"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className={styles.deskicon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                  >
                    <path
                      fill-rule="evenodd"
                      fill="#F58648"
                      d="M24.936 10.745c-.539.747-1.403 1.309-2.208 1.812.633.462 1.269.911 1.954 1.313.338.198.236.66-.104.783a71.41 71.41 0 0 1-1.551.551c-.24.08-.486.18-.736.255.54.65.969 1.468 1.411 2.14.171.261-.054.619-.356.615-.877-.013-1.817.044-2.708-.049l.02.266c.091.311.165.629.262.937.173.554.387 1.09.599 1.63.105.265-.216.582-.483.479-.579-.222-1.16-.441-1.737-.667-.305-.119-.63-.243-.931-.396.01 1.032-.125 2.078-.292 3.091a.303.303 0 0 1-.083.154c-.037.096-.099.182-.211.214-.629.176-1.39-.554-1.83-.942a7.43 7.43 0 0 1-.585-.581 38.895 38.895 0 0 1-.988 2.237c-.142.294-.542.226-.701 0-.342-.49-.672-.99-.999-1.49-.126-.192-.26-.384-.385-.582-.463.793-1.047 1.549-1.577 2.292-.197.276-.657.266-.755-.097-.228-.847-.584-1.704-.793-2.567-.327.201-.691.368-.999.58-.463.319-.85.73-1.409.872-.224.056-.511-.114-.488-.369.084-.937.06-1.926.194-2.868-.213.075-.438.129-.603.191l-1.721.642c-.302.113-.57-.22-.499-.495.202-.793.378-1.593.575-2.387a84.422 84.422 0 0 0-2.615-.059c-.291 0-.527-.346-.35-.603.505-.734.964-1.506 1.493-2.225-.297-.117-.59-.253-.883-.363a37.551 37.551 0 0 0-1.576-.544c-.339-.108-.363-.513-.093-.709.674-.491 1.314-1.024 1.967-1.541-.644-.458-1.286-.919-1.949-1.349-.261-.17-.301-.583 0-.744a24.55 24.55 0 0 1 1.841-.89c.243-.105.493-.225.748-.321-.584-.66-1.087-1.419-1.548-2.13-.192-.299.126-.623.435-.561.879.177 1.752.243 2.636.307-.317-.89-.514-1.829-.735-2.743-.064-.263.187-.586.481-.476.749.281 1.509.551 2.26.839-.04-.316-.042-.646-.06-.894-.049-.654-.136-1.368.136-1.98.098-.221.43-.227.582-.075.445.446.896.885 1.363 1.308.191.173.397.338.6.507.41-.909.809-1.81 1.103-2.767.085-.275.448-.39.66-.173.546.564 1.171 1.2 1.656 1.888.41-.674 1.015-1.303 1.478-1.896.187-.239.542-.068.624.163.305.862.614 1.728.894 2.6.766-.633 1.578-1.222 2.386-1.797.239-.17.531.063.545.31.052.877.018 1.754-.07 2.626l.18-.047c.354-.125.711-.242 1.068-.347.427-.125 1.265-.534 1.713-.339.477.207.266.746.143 1.101-.238.691-.47 1.387-.733 2.07.031-.001.061-.005.094.002.432.084.919-.008 1.357-.03.463-.024.927-.038 1.391-.056.252-.009.481.322.312.54-.509.658-1.006 1.435-1.599 2.054.909.188 1.946.741 2.631 1.206.174.119.291.38.151.574zM8.064 7.902c-1.997.678-2.143 3.275-.671 4.574.203.179.403.304.602.399 1.58.03 3.266-.482 3.623-2.262.429-2.132-1.697-3.341-3.554-2.711zm6.493-.31c-1.925 3.236-3.739 6.482-6.113 9.461.262-.034.529-.052.779-.072a11.39 11.39 0 0 1 1.295-.051c1.307-3.182 3.027-6.579 5.101-9.429-.355.04-.708.071-1.062.091zm3.736 5.646c-.822-1.667-3.106-1.987-4.378-.614-1.129 1.218-.866 2.961.196 4.033.447.274 1.011.376 1.649.329 1.838-.136 3.422-1.946 2.533-3.748zM15.5 15.421a1.163 1.163 0 0 1-.64-.613c-.011-.017-.027-.029-.037-.046a.932.932 0 0 1 .023-.972l.001-.003a.899.899 0 0 1 .544-.459l.005-.002c.02-.005.039-.012.06-.016.06-.019.121-.039.186-.048.723-.099 1.477.467 1.406 1.226-.069.745-.858 1.186-1.548.933zm-7.282-4.326c-.398-.336-.501-.976-.16-1.386a.958.958 0 0 1 .229-.189.94.94 0 0 1 1.27-.058c1.038.86-.303 2.504-1.339 1.633z"
                    />
                  </svg>
                </div>
                <p>
                  {" "}
                  Welcome offers for you! Use code: 'WELCOMEZENITH' and enjoy up
                  to 20%* more savings on flights, hotels, holidays & more.
                </p>
              </div> */}
              <div className={styles.zenith_signin_form}>
                <p class={styles.form_heading_text}>Just one more thing.</p>
                <div className={styles.input_flex}>
                  {this.state.registerAPIErr !== "" ? (
                    <div className={styles.email_error_msg}>
                      {this.state.registerAPIErr}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className={styles.zenith_input}>
                    <label>
                      {" "}
                      First Name <span style={{ color: "red" }}>*</span>
                    </label>

                    <div className={styles.error_class}>
                      <input
                        className={styles.email_id}
                        type="text"
                        placeholder="Enter Your First Name"
                        maxLength="100"
                        value={this.state.signupForm.firstName}
                        onChange={this.onChangeSignFName}
                      />
                      {this.state.signupFormErr.firstName !== "" ? (
                        <div className={styles.email_error_msg}>
                          {this.state.signupFormErr.firstName}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div
                    className={`${styles.zenith_input} ${styles.zenith_last_name}`}
                  >
                    <label>
                      Last Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className={`${styles.error_class} ${styles.marginlr}`}>
                      <input
                        className={styles.email_id}
                        type="text"
                        placeholder="Enter Your Last Name"
                        maxLength="100"
                        value={this.state.signupForm.lastName}
                        onChange={this.onChangeSignLName}
                      />
                      {this.state.signupFormErr.lastName !== "" ? (
                        <div className={styles.email_error_msg}>
                          {this.state.signupFormErr.lastName}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.mob_new}>
                  <label>
                    {" "}
                    Mobile No. <span style={{ color: "red" }}>*</span>
                  </label>
                  <div
                    className={`${styles.country_drp} ${styles.dropdown_section}`}
                  >
                    <div className={styles.error_class}>
                      <div
                        className={`${styles.zenith_input} ${styles.zenith_input_isd}`}
                      >
                        <IsdCountryDropdown
                          theme={"theme5"}
                          CountryListOptions={this.state.originCountries}
                          selectCountryCode={
                            this.selectCountryCodeFunctionTraveller
                          }
                          searchText={this.state.signupForm.countryCode}
                          selectedCountryInfo={this.state.selectedCountry}
                          onClickInputCountry={
                            this.onClickInputCountryTraveller
                          }
                          onChangeInputCountryCodeFunction={
                            this.onChangeInputCountryCodeFunctionTraveller
                          }
                          onKeyDownCountry={this.onKeyDownCountryCodeTraveller}
                          placeholder={"Enter ISD"}
                          {...this.props.data.ISDstyles}
                          isSignUpCountryCode={true}
                        />
                        {this.state.signupFormErr.countryCode !== "" ? (
                          <div className={styles.email_error_msg_isd}>
                            {this.state.signupFormErr.countryCode}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className={styles.error_class}>
                      <div className={styles.zenith_input}>
                        <input
                          className={styles.email_id}
                          type="text"
                          placeholder="Enter Your Mobile No."
                          maxLength="22"
                          value={this.state.signupForm.mobileNo}
                          onChange={this.onChangeSignMobile}
                        />
                        {this.state.signupFormErr.mobileNo !== "" ? (
                          <div className={styles.email_error_msg}>
                            {this.state.signupFormErr.mobileNo}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {/* <div className={styles.error_class}>
                        <CountryDropdownComp
                        countryFlag={this.state.originCountries}
                        searchText={this.state.signupForm.nationality}
                        selectCountry={this.onClickNationalityHandler}
                        selectedCountry={this.state.selectedNationality}
                        onChangeInputCountryCode={this.onChangeInputNationality}
                        placeholder={'Country'}
                        isSignUpNationality={true}
                        {...this.props.data.Countrystyles}
                    />
                            {this.state.signupFormErr.nationality !== "" ? <div className={styles.email_error_msg}>{this.state.signupFormErr.nationality}</div> : ""}
                         </div> */}
                  </div>
                </div>
                <div className={styles.error_class}>
                  <input
                    className={styles.email_id}
                    id="email"
                    autoComplete="off"
                    type="email"
                    placeholder="Enter Your Email ID"
                    maxLength="50"
                    disabled={
                      this.props.data.emailId !== "" ||
                      this.state.signupForm.email
                        ? true
                        : false
                    }
                    value={this.state.signupForm.email}
                    onChange={this.onChangeSignEmail}
                  />
                  {this.state.signupFormErr.email !== "" ? (
                    <div className={styles.email_error_msg}>
                      {this.state.signupFormErr.email}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {this.state.isPasswordRequired ? (
                  <>
                    <div className={styles.error_class}>
                      <div
                        className={`${styles.zenith_input} ${styles.zenith_password}`}
                      >
                        <label>
                          {" "}
                          Password <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className={styles.email_id}
                          id="password"
                          type="password"
                          autoComplete="new-password"
                          placeholder="Enter Your Password"
                          maxLength="50"
                          onChange={this.onChangeSignPassword}
                        />
                        {/* <div className={styles.special_character}>
                          <p>
                            Password must be between 8-13 characters in length
                            and must comprise of at least 1 lowercase alphabet
                            (a-z), 1 uppercase alphabet (A-Z), 1 number (0-9)
                            and 1 special character
                          </p>
                        </div> */}
                        {this.state.signupFormErr.password !== "" ? (
                          <div className={styles.email_error_msg}>
                            {this.state.signupFormErr.password}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className={styles.error_class}>
                      <div
                        className={`${styles.zenith_input} ${styles.zenith_c_password}`}
                      >
                        <label>
                          Confirm New-Password{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className={styles.email_id}
                          id="password"
                          type="password"
                          autoComplete="new-password"
                          placeholder="Enter Your Confirm Password"
                          maxLength="50"
                          onChange={this.onChangeSignCnfPassword}
                        />
                        {/* <div className={styles.special_character}>
                          <p>
                            Password must be between 8-13 characters in length
                            and must comprise of at least 1 lowercase alphabet
                            (a-z), 1 uppercase alphabet (A-Z), 1 number (0-9)
                            and 1 special character
                          </p>
                        </div> */}
                        {this.state.signupFormErr.confirmPassword !== "" ? (
                          <div className={styles.email_error_msg}>
                            {this.state.signupFormErr.confirmPassword}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                ) : null}
                <button
                  className={styles.btn_login}
                  onClick={this.finalSignupClick}
                >
                  Let's Go
                </button>
              </div>
              {/* <p
                onClick={() => {
                  this.props.data.onClickCross();
                }}
                className={styles.do_later}
              >
                I’ll do it later{" "}
              </p> */}
            </div>
          </>
        );
      case "ForgotPassword":
        return (
          <>
            <div className={styles.login_flex}>
              <div className={styles.login_banner}>
                {/* <img src="/images/login_banner.png" alt="login" /> */}
                {this.props?.data?.siteData?.data?.signin?.upload_image ? (
                  <img
                    src={`/shared/api/media/${this.props?.data?.siteData?.data?.signin?.upload_image}`}
                    alt="Uploaded Image"
                  />
                ) : (
                  <img src="/images/login_banner.png" alt="Default Image" />
                )}
              </div>
              <div className={`${styles.form_flex} ${styles.password_section}`}>
                <div className={styles.heading_text_div}>
                  <svg
                    onClick={() => {
                      this.setState({ popupType: "LogIn" });
                      this.setState({ forgotPassText: false });
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="24"
                  >
                    <path
                      fill-rule="evenodd"
                      fill="#FFF"
                      d="m14.442 3.241-8.834 8.747 8.837 8.749a1.893 1.893 0 0 1 0 2.695 1.938 1.938 0 0 1-2.721 0L1.536 13.343a1.878 1.878 0 0 1-.529-.99 1.887 1.887 0 0 1 .526-1.718L11.721.547a1.938 1.938 0 0 1 2.721 0 1.89 1.89 0 0 1 0 2.694z"
                    />
                  </svg>
                  <div className={styles.login_by_mail_id_text + " " + "my-4"}>
                    Forgot Your Password ?
                    {/* <button onClick={() => { this.setState({ popupType: "LogIn" }) }} className={styles.back_btn}>Back</button> */}
                  </div>
                </div>
                <div className={styles.zenith_signin}>
                  <p className={styles.passowrd_instr}>
                    We'll send you an email with instructions
                  </p>
                  <div className={styles.zenith_input}>
                    <label> Email ID</label>
                    <input
                      className={styles.email_id + " !mb-0"}
                      type="email"
                      placeholder="Enter Email ID"
                      value={this.state.forgotPasswordEmail}
                      maxLength="50"
                      onChange={this.onChangeForgotPassEmail}
                    />
                    {this.state.forgotPasswordErr !== "" ? (
                      <div className={styles.email_error_msg}>
                        {this.state.forgotPasswordErr}
                      </div>
                    ) : (
                      ""
                    )}
                    {!this.state.forgotPassText && (
                      <button
                        className={styles.btn_login}
                        onClick={this.onClickForgotSubimitBtn}
                      >
                        Reset Password
                      </button>
                    )}
                    {!this.state.forgotPassText && (
                      <div style={{ textAlign: "center" }}>
                        <span
                          className={styles.back_to_login}
                          onClick={() => {
                            this.setState({ popupType: "LogIn" });
                          }}
                        >
                          Back to Login
                        </span>
                      </div>
                    )}
                    {/* {this.state.forgotPassText && <div className={styles.link_to_email}>{'Reset password verification link successfully sent on registered email id'}</div>} */}
                    {/* {this.state.forgotPassText && <div className={styles.valid_link}>Verification Link Valid for <span>24 hours</span></div>} */}
                    {this.state.forgotPassText && (
                      <>
                        <div className={styles.modal_container}>
                          <div
                            className={styles.modal_background}
                            onClick={() => {}}
                          ></div>
                          <div className={styles.modal_overflow}>
                            <div className={styles.modal_content}>
                              <div
                                onClick={() => {
                                  this.props.data.onClickCross();
                                  this.setState({ forgotPassText: false });
                                }}
                                className={styles.modal_close}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="#919191"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                  ></path>
                                </svg>
                                {/* close btn */}
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                        <defs>
                            <filter id="g63t2xnqea">
                                <feFlood flood-color="#919191" flood-opacity="1" result="floodOut"/>
                                <feComposite operator="atop" in="floodOut" in2="SourceGraphic" result="compOut"/>
                                <feBlend in="compOut" in2="SourceGraphic"/>
                            </filter>
                        </defs>
                        <g filter="url(#g63t2xnqea)">
                            <path fill-rule="evenodd" fill="#97144D" d="M8.1 17.999C4.036 17.999.001 13.964.001 8.1.001 4.034 4.036.001 8.1.001c5.866 0 9.899 4.033 9.899 8.099 0 5.864-4.033 9.899-9.899 9.899zm0-17.18C4.478.819.819 4.476.819 8.1c0 5.422 3.659 9.081 7.281 9.081 5.424 0 9.081-3.659 9.081-9.081 0-3.624-3.657-7.281-9.081-7.281zm1.478 8.185 2.78 2.774a.411.411 0 1 1-.581.582L9.003 9.58l-2.78 2.78a.412.412 0 0 1-.582-.582l2.774-2.774-2.774-2.78a.41.41 0 0 1 .288-.703.411.411 0 0 1 .294.121l2.78 2.774 2.774-2.774a.41.41 0 0 1 .281-.121.408.408 0 0 1 .3.703l-2.78 2.78z"/>
                        </g>
                         </svg> */}
                              </div>
                              <div className={styles.modal_sectiontop}>
                                {/* <div className={styles.email_headinga_text}>Email Sent Successfully!</div> */}

                                <div className={styles.modalb_wrap}>
                                  <div className={styles.modb_icon}>
                                    {/* <img src="/images/email-i.svg" alt="" /> */}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="84"
                                      height="65"
                                    >
                                      <defs>
                                        <filter id="9jxuaahoga">
                                          <feFlood
                                            flood-color="#266AAC"
                                            flood-opacity="1"
                                            result="floodOut"
                                          />
                                          <feComposite
                                            operator="atop"
                                            in="floodOut"
                                            in2="SourceGraphic"
                                            result="compOut"
                                          />
                                          <feBlend
                                            in="compOut"
                                            in2="SourceGraphic"
                                          />
                                        </filter>
                                      </defs>
                                      <g filter="url(#9jxuaahoga)">
                                        <path
                                          fill-rule="evenodd"
                                          fill="#97144D"
                                          d="m59.223 26.023 23.7-21.299c.701 1.271 1.071 2.693.177 4.139v47.273c.893 1.606.438 3.18-.417 4.547l-23.46-34.66zm-18.801 6.069a3.037 3.037 0 0 0 3.378-.183L78.495.697C77.389.235 76.201-.002 74.1 0h-66c-.299-.001-1.487.235-2.592.694l34.914 31.398zM1.092 4.727A8.64 8.64 0 0 0 0 8.863v47.273a8.644 8.644 0 0 0 1.317 4.547l23.466-34.665L1.092 4.727zm53.649 25.335-7.116 6.397a9.566 9.566 0 0 1-5.7 1.92 8.916 8.916 0 0 1-5.325-1.743l-7.332-6.591L5.979 64.447c.967.356 1.989.543 2.121-.347h66c1.932.89 2.954.703 3.921.347l-23.28-34.385z"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                  <div className={styles.modb_title}>
                                    <div>
                                      {" "}
                                      Reset password email sent successfully !{" "}
                                    </div>
                                    <div>
                                      {" "}
                                      Its Simple..Just follow the instructions
                                      and reset password.
                                    </div>
                                  </div>
                                  {/* <button onClick={()=>{this.props.data.onClickCross();this.setState({ forgotPassText: false })}} className={styles.ok_btn}>OK</button> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case "VerifyEmailId":
        return (
          <>
            <div
              className={styles.back}
              onClick={() => {
                this.setState({ popupType: "LogIn" });
              }}
            >
              Back
            </div>
            <div className={styles.login_by_mail_id_text}>
              Verify Your Email ID
            </div>
            <div className={styles.otp_to_email}>
              OTP has been sent to Email ID: <span>abcd@gmail.com</span>
            </div>
            <div className="relative w-full">
              <input
                className={styles.email_id + " !mb-0"}
                id="email"
                type="email"
                placeholder="OTP"
                maxLength="50"
                onChange={props.onChangeEmailId}
              />
              <span className={styles.resend_otp}>Resend OTP</span>
            </div>
            {props.OTPErrorMsg !== "" ? (
              <div className={styles.email_error_msg}>{props.OTPErrorMsg}</div>
            ) : (
              ""
            )}
            <button className={styles.btn_login} onClick={props.onOTPSignUp}>
              Signup
            </button>
            <div className={styles.or_login_with}>or Signup Via</div>
            <FacebookGoogleLogin
              getSignUpForm={this.getSignUpForm}
              signupText={"SignUp"}
              siteData={this.props.data.siteData}
            />
          </>
        );
      case "ChangePassword":
        return (
          <>
            {this.state.resetTokenExpiry ? (
              <ResetPassword
                cssfile={this.props.data.logincss}
                onClickBackLink={() => {
                  this.setState({ popupType: "LogIn" });
                }}
                onClickConfirmbtn={this.onClickConfirmbtn}
                newPasswordErr={this.state.passwordObjErr.newPassword}
                confirmPasswordErr={this.state.passwordObjErr.confirmPassword}
                changePasswordAPIErr={this.state.changePasswordAPIErr}
                onChangeNewPassword={(e) => {
                  this.setState({
                    passwordObj: {
                      ...this.state.passwordObj,
                      newPassword: e.target.value,
                    },
                    passwordObjErr: {
                      ...this.state.passwordObjErr,
                      newPassword: "",
                    },
                  });
                }}
                onChangeConfirmPassword={(e) => {
                  this.setState({
                    passwordObj: {
                      ...this.state.passwordObj,
                      confirmPassword: e.target.value,
                    },
                    passwordObjErr: {
                      ...this.state.passwordObjErr,
                      confirmPassword: "",
                    },
                  });
                }}
                hidePass={this.state.hidePass}
                onClickHidePass={() => {
                  this.setState({ hidePass: !this.state.hidePass });
                }}
                hidePassConf={this.state.hidePassConf}
                onClickHidePassConf={() => {
                  this.setState({ hidePassConf: !this.state.hidePassConf });
                }}
              />
            ) : (
              <>
                {this.props.data.isMobile ? (
                  <ChangePasswordMob
                    cssfile={this.props.data.logincss}
                    onClickBackLink={() => {
                      this.setState({ popupType: "LogIn" });
                    }}
                    onClickConfirmbtn={this.onClickConfirmbtn}
                    newPasswordErr={this.state.passwordObjErr.newPassword}
                    confirmPasswordErr={
                      this.state.passwordObjErr.confirmPassword
                    }
                    changePasswordAPIErr={this.state.changePasswordAPIErr}
                    onChangeNewPassword={(e) => {
                      this.setState({
                        passwordObj: {
                          ...this.state.passwordObj,
                          newPassword: e.target.value,
                        },
                        passwordObjErr: {
                          ...this.state.passwordObjErr,
                          newPassword: "",
                        },
                      });
                    }}
                    onChangeConfirmPassword={(e) => {
                      this.setState({
                        passwordObj: {
                          ...this.state.passwordObj,
                          confirmPassword: e.target.value,
                        },
                        passwordObjErr: {
                          ...this.state.passwordObjErr,
                          confirmPassword: "",
                        },
                      });
                    }}
                    hidePass={this.state.hidePass}
                    onClickHidePass={() => {
                      this.setState({ hidePass: !this.state.hidePass });
                    }}
                    hidePassConf={this.state.hidePassConf}
                    onClickHidePassConf={() => {
                      this.setState({ hidePassConf: !this.state.hidePassConf });
                    }}
                  />
                ) : (
                  <ChangePassword
                    cssfile={this.props.data.logincss}
                    onClickBackLink={() => {
                      this.setState({ popupType: "LogIn" });
                    }}
                    onClickConfirmbtn={this.onClickConfirmbtn}
                    newPasswordErr={this.state.passwordObjErr.newPassword}
                    confirmPasswordErr={
                      this.state.passwordObjErr.confirmPassword
                    }
                    changePasswordAPIErr={this.state.changePasswordAPIErr}
                    onChangeNewPassword={(e) => {
                      this.setState({
                        passwordObj: {
                          ...this.state.passwordObj,
                          newPassword: e.target.value,
                        },
                        passwordObjErr: {
                          ...this.state.passwordObjErr,
                          newPassword: "",
                        },
                      });
                    }}
                    onChangeConfirmPassword={(e) => {
                      this.setState({
                        passwordObj: {
                          ...this.state.passwordObj,
                          confirmPassword: e.target.value,
                        },
                        passwordObjErr: {
                          ...this.state.passwordObjErr,
                          confirmPassword: "",
                        },
                      });
                    }}
                    hidePass={this.state.hidePass}
                    onClickHidePass={() => {
                      this.setState({ hidePass: !this.state.hidePass });
                    }}
                    hidePassConf={this.state.hidePassConf}
                    onClickHidePassConf={() => {
                      this.setState({ hidePassConf: !this.state.hidePassConf });
                    }}
                  />
                )}
              </>
            )}
          </>
        );
      case "PasswordUpdatedSuccessfully":
        return (
          <>
            {/* <div className={styles.back} onClick={() => /window.location.href = "/" }}>Back</div> */}
            <div className={styles.update_password}>
              <img src="/images/refundable.svg" alt="check" />
              <div
                className={styles.login_by_mail_id_text + " " + "!text-center"}
              >
                Password Updated!
              </div>
              <div className={styles.pswd_success}>
                Your password has been changed successfully. Use your new
                password to Sign In.
              </div>
              <button
                className={styles.btn_login}
                onClick={() => {
                  /* this.setState({ popupType: "LogIn" }) */ window.location.href =
                    "/";
                }}
              >
                Back to Sign In
              </button>
            </div>
          </>
        );
      case "LoginViaOTP":
        return (
          <>
            <div className={styles.personal_login_text}>
              <div
                className={
                  this.state.toggleAgentLogin
                    ? ""
                    : styles.personal_login_tab_active
                }
                onClick={() => {
                  this.setState({ toggleAgentLogin: false });
                }}
              >
                <span>PERSONAL LOGIN</span>
              </div>
              <div
                className={
                  !this.state.toggleAgentLogin
                    ? ""
                    : styles.personal_login_tab_active
                }
                onClick={() => {
                  this.setState({ toggleAgentLogin: true });
                }}
              >
                <span>AGENT LOGIN</span>
              </div>
            </div>
            <div className="mb-2">
              <div className={styles.login_by_mail_id_text}>Login Via OTP</div>
            </div>
            <input
              className={styles.email_id}
              type="email"
              placeholder="Email ID"
              maxLength="50"
              value={this.state.loginWithOTPEmail}
              onChange={this.onChangeLoginOTPEmail}
            />
            {this.state.loginOTPEmailErr !== "" ? (
              <div className={styles.email_error_msg}>
                {this.state.loginOTPEmailErr}
              </div>
            ) : (
              ""
            )}
            <button className={styles.btn_login} onClick={this.onClickSendOTP}>
              Send OTP
            </button>
            <div className={styles.or_login_with}>Login With</div>
            <FacebookGoogleLogin
              getSignUpForm={this.getSignUpForm}
              siteData={this.props.data.siteData}
            />
            <div className={styles.noaccount}>
              Don't have an account{" "}
              <span
                onClick={() => {
                  this.setState({ popupType: "BeforeSignUp" });
                }}
              >
                Signup
              </span>
            </div>
            {/* <div className={styles.policytext}>By proceeding, you agree to Elevate Trips <span onClick={() => { window.open(`${window.location.origin}/Privacy_policy`, '_blank') }}> Privacy Policy</span>, <span onClick={() => { window.open(`${window.location.origin}/page/termsofuse`, '_blank') }}>User Agreement</span> and <span onClick={() => { window.open(`${window.location.origin}/Terms_and_Conditions`, '_blank') }}>T&Cs</span></div> */}
          </>
        );
      case "VerifyOTP":
        return (
          <>
            <div
              className={styles.back}
              onClick={() => {
                this.setState({ popupType: "LogIn" });
              }}
            >
              Back
            </div>
            <div className={styles.login_by_mail_id_text}>Verify OTP</div>
            <div className={styles.otp_to_email}>
              OTP has been sent to Email ID:{" "}
              <span>{this.state.loginWithOTPEmail}</span>
            </div>
            <div className="relative w-full">
              <input
                className={styles.email_id + " !mb-0"}
                type="text"
                placeholder="OTP"
                maxLength="6"
                onChange={(e) => {
                  this.setState({
                    verifyOTPEmail: e.target.value,
                    verifyOTPEmailErr: "",
                  });
                }}
              />
              <span className={styles.resend_otp}>Resend OTP</span>
            </div>
            {this.state.verifyOTPEmailErr !== "" ? (
              <div className={styles.email_error_msg}>
                {this.state.verifyOTPEmailErr}
              </div>
            ) : (
              ""
            )}
            <button className={styles.btn_login} onClick={this.onOTPLogin}>
              Login
            </button>
            <div className={styles.or_login_with}>or Login With</div>
            <FacebookGoogleLogin
              getSignUpForm={this.getSignUpForm}
              siteData={this.props.data.siteData}
            />
          </>
        );
      case "SignUpSuccessful":
        return (
          <div className={styles.SignUpSuccessful}>
            <img src={"/images/complete_tick.svg"} alt="" />
            <div className={styles.SignUpSuccessful_inner}>
              <div className={styles.sucess_signup}>Success</div>
              <span>Congratulations !! </span>
              your registration was successful on Company..
            </div>
            <button onClick={this.onContinueClickHandler}>
              {"CONTINUE".toUpperCase()}
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    return (
      <>
        <ModalPopupComponent
          isMobile={this.props.data.isMobile}
          isPopup={this.state.headerPopup}
          onClosePopup={this.onClosePopup}
          modalCss={this.props.data.modalCss}
          showCrossButton={
            this.state.popupType == "SignUp" || this.props.data.isMobile
              ? false
              : true
          }
        >
          {this.renderLoginPopup(
            this.state.isSuccessPopupVisible
              ? "SignUpSuccessful"
              : this.props.data.directOpenLinkPopup
              ? this.props.data.directOpenLinkPopup
              : this.state.popupType
          )}
        </ModalPopupComponent>
      </>
    );
  }
}
